'use client'
import Image from 'next/image'
import { FaStopwatch, FaStrava, FaApple } from 'react-icons/fa'

const Component = ({ user, activity }) => {
  return <>
    <div className='flex items-center justify-center text-center'>
      
      {(activity.manual && !activity.integrationType) && <div className='flex flex-col items-center gap-2'>
        <FaStopwatch className='text-chCaption' style={{ fontSize: '30px' }} /> 
        {(activity.manual && !activity.integrationType) && 'Manually Entered'}
      </div>}
                    
      {activity.integrationType === 'strava' && <div className='flex flex-col items-center gap-2'>
        <FaStrava className='text-chCaption' style={{ fontSize: '30px' }} /> 
        <a href={`http://www.strava.com/activities/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>Strava</a>
      </div>}
      
      {activity.integrationType === 'uacf' && <div className='flex flex-col items-center gap-2'>
        <a href={`https://www.mapmyfitness.com/workout/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          <Image width={30} height={30} src='/mapmyfitness.png' alt='Map My Fitness' />
        </a>
        <a href={`https://www.mapmyfitness.com/workout/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          Map My Fitness
        </a>
      </div>}
      
      {activity.integrationType === 'garmin' && <div className='flex flex-col items-center gap-2'>
        <a href={`https://connect.garmin.com/modern/activity/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          <Image src='/garmin-app-icon.png' width={30} height={30} alt={'Garmin Connect'} />
        </a>
        <a href={`https://connect.garmin.com/modern/activity/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          Garmin
        </a>
      </div>}

      {activity.integrationType === 'fitbit' && <div className='flex flex-col items-center gap-2'>
        <a href={`https://www.fitbit.com/activities/exercise/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          <Image src='/fitbit-icon.png' width={30} height={30} alt={'Fitbit'} />
        </a>
        <a href={`https://www.fitbit.com/activities/exercise/${activity.integrationActivityId}`} target='_blank' rel='noreferrer'>
          Fitbit
        </a>
      </div>}

      {activity.integrationType === 'coros' && <div className='flex flex-col items-center gap-2'>
        <a href={`https://t.coros.com/activity-detail?labelId=${activity.integrationActivityId}&sportType=100`} target='_blank' rel='noreferrer'>
          <Image src='/coros.png' width={30} height={30} alt={'Coros'} />
        </a>
        <a href={`https://t.coros.com/activity-detail?labelId=${activity.integrationActivityId}&sportType=100`} target='_blank' rel='noreferrer'>
          Coros
        </a>
      </div>}

      {activity.integrationType === 'apple' && <div className='flex flex-col items-center gap-2'>
        <FaApple className='text-chCaption' style={{ fontSize: '32px', height: '30px' }} /> 
        Apple Health
      </div>}

      {activity.integrationType === 'health-connect' && <div className='flex flex-col items-center gap-2'>
        <Image src='/health-connect.png' width={30} height={30} alt={'Health Connect'} />
        Health Connect
      </div>}
      
      {!['apple', 'coros', 'uacf', 'fitbit', 'strava', 'garmin', 'health-connect'].includes(activity.integrationType)  && 
        <div className='flex flex-col items-center gap-2'>
          {activity.integrationType}
        </div>
      }

    </div>   
  </>
}

export default Component